/**
 * @generated SignedSource<<75b7547bdb761c077d63fea07f0b073c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnsupportedBrowserContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "UnsupportedBrowserContent_viewer";
};
export type UnsupportedBrowserContent_viewer$key = {
  readonly " $data"?: UnsupportedBrowserContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnsupportedBrowserContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnsupportedBrowserContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e187bde3f88caad604eb51f12f02df7b";

export default node;
